"use strict";
// packages/types/src/affiliate.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateCommissionStatus = exports.AffiliateClientLinkType = exports.AffiliateAccountStatus = void 0;
var AffiliateAccountStatus;
(function (AffiliateAccountStatus) {
    AffiliateAccountStatus["PENDING"] = "PENDING";
    AffiliateAccountStatus["APPROVED"] = "APPROVED";
    AffiliateAccountStatus["SUSPENDED"] = "SUSPENDED";
})(AffiliateAccountStatus || (exports.AffiliateAccountStatus = AffiliateAccountStatus = {}));
var AffiliateClientLinkType;
(function (AffiliateClientLinkType) {
    AffiliateClientLinkType["REFERRAL"] = "REFERRAL";
    /** Reserved for future use — org-initiated links without commission. */
    AffiliateClientLinkType["MANUAL"] = "MANUAL";
})(AffiliateClientLinkType || (exports.AffiliateClientLinkType = AffiliateClientLinkType = {}));
var AffiliateCommissionStatus;
(function (AffiliateCommissionStatus) {
    AffiliateCommissionStatus["PENDING"] = "PENDING";
    AffiliateCommissionStatus["PAID"] = "PAID";
    AffiliateCommissionStatus["REVERSED"] = "REVERSED";
})(AffiliateCommissionStatus || (exports.AffiliateCommissionStatus = AffiliateCommissionStatus = {}));
